import store from './index.js';

const base = /test/.test(window.location.hostname)
    ? 'https://platform.test.vsat.cloud/workflow/api/'
    : 'https://platform.vsat.cloud/workflow/api/';

const stateMappers = {};
Object.keys(store.state).forEach(key => {
    return (stateMappers[key] = state => state[key]);
});
const getterKeys = Object.keys(store.getters);
const actionsKeys = Object.keys(store._actions);
const mutationKeys = Object.keys(store._mutations);

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export const REQUEST = params => {
    const TOKEN = store.state.USER.TOKEN;
    const options = {
        headers: {
            'content-type': 'application/json',
        },
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, same-origin, *omit
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
    };

    if (params.noAuth) {
        console.log('public request');
    } else if (TOKEN) {
        options.headers.Authorization = `Bearer ${TOKEN}`;
    } else {
        throw new Error('Token required');
    }

    if (params.data) {
        options.body = JSON.stringify(params.data); // must match 'Content-Type' header
        delete params.data;
    }

    if (params.headers) {
        options.headers = { ...options.headers, ...params.headers };
        delete params.headers;
    }

    return fetch(`${base}${params.url}`, {
        ...options,
        ...params,
    })
        .then(response => response.json())
        .then(res => {
            if (res.code == '10008') {
                window.localStorage.user = '';
                window.location.href = '';
                return;
            }
            return res;
        }); // parses response to JSON
};

export default {
    computed: {
        ...mapState(stateMappers),
        ...mapGetters(getterKeys),
    },
    methods: {
        REQUEST,
        ...mapMutations(mutationKeys),
        ...mapActions(actionsKeys),
    },
};
